import React, { Component } from 'react';
import { Card } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    Tooltip,
    Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import * as util from '../../library/utilitys'; 
import * as charts from '../../library/charts'; 

import Loading from './Loading'; 

ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    Tooltip,
    Legend,
    ChartDataLabels
);

class DashboardGroupedHorizontalChart extends Component {
    render() {
        const { data, title, icon, bg='primary' } = this.props;

        const antDesignColors = charts.getChartColors();

        const labels = data?.labels || [];
        const datasets = data?.datasets || [];

        const hasData = labels.length > 0 && datasets.length > 0;

        const coloredDatasets = datasets.map((dataset, index) => ({
            ...dataset,
            backgroundColor: antDesignColors[index % antDesignColors.length]
        }));

        const chartData = {
            labels: labels,
            datasets: coloredDatasets
        };

        const options = {
            responsive: true,
            maintainAspectRatio: false, 
            indexAxis: 'y',
            responsive: true,
            plugins: {
                legend: {
                    position: 'bottom',
                    align: 'end'
                },
                tooltip: {
                    // mode: 'index',
                    // intersect: false,
                    callbacks: {
                        label: context => util.formatNumber(context.raw)
                    }
                },
                datalabels: {
                    anchor: 'start',
                    align: 'end',
                    color: 'white',
                    formatter: value => util.formatNumber(value),
                    font: {
                        weight: 'normal',
                        size: 10
                    }
                }
            },
            scales: {
                x: {
                    type: 'logarithmic',
                    min: 0,
                    grid: { display: false },
                    ticks: { display: false }
                },
                y: {
                    grid: { display: false }
                }
            }
        };

        return (
            <Card className="card-border mb-0">
                <Card.Header className={`card-header-action bg-${bg}`}>
                    <h6 className="text-white">{icon && <i className={`${icon} me-2`}></i>}{title}</h6>
                </Card.Header>
                <Card.Body style={{ maxHeight: '400px', position: 'relative' }}>
                    <div style={{ height: '100%', minHeight: '350px' }}>
                        {hasData ? (
                            <Bar data={chartData} options={options} plugins={[ChartDataLabels]} />
                        ) : (
                            <Loading height="300px" variant="primary" />
                        )}
                    </div>
                </Card.Body>
            </Card>
        );
    }
}

export default DashboardGroupedHorizontalChart;
